export default function erieReducer(state = [], action) {
  switch (action.type) {
    case "FETCH_ERIE":
      return [].concat.apply([], [...state, action.payload]);
    default:
      return state;
  }
}
